import { fetchWithCSRF } from '../csrf_utils';

function saveImage(image, url, onClose) {

  if (image.imageBase64) {
    const spinner = $('.loading-spinner');
    spinner.show();
    
    // Use the imported fetchWithCSRF function
    fetchWithCSRF(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        image: image.imageBase64,
        filename: image.fullName,
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'success') {
          onClose();
        } else {
          window.rollbar.error('Upload failed:', data);
        }
      })
      .catch(error => {
        window.rollbar.error('Upload error:', error);
        // Show user-friendly error message
        alert('Upload failed. Please try again.');
      })
      .finally(() => {
        spinner.hide();
      });
  }
}

document.addEventListener('turbolinks:load', function() {
  const filerobotImageEditor = document.querySelector('#filerobot-image-editor');
  if (!filerobotImageEditor) {
    return;
  }

  const fileUrl = filerobotImageEditor.dataset.fileUrl;
  const options = {
    source: filerobotImageEditor.dataset.source,
    defaultTabId: 'Annotate',
    defaultToolId: 'Pen',
    showBackButton: true,
    avoidChangesNotSavedAlertOnLeave: true,
  }

  const editor = new window.FilerobotImageEditor(
    filerobotImageEditor,
    options
  );

  const onClose = () => {
    window.location.href = filerobotImageEditor.dataset.backUrl;
    editor.terminate();
  }

  editor.render({
    onClose: () => {
      onClose()
    },

    onSave: (savedImageData) => {
      saveImage(savedImageData, fileUrl, onClose);
    }
  });
});